import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const CurrencyContext = createContext(null);
export const useCurrency = () => useContext(CurrencyContext);

const SYMBOLS = { USD: "$", NGN: "₦", EUR: "€", GBP: "£" };

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState(localStorage.getItem("currency") || "USD");
  const [rates, setRates] = useState({ USD: 1, NGN: 1550 });

  useEffect(() => {
    api.get("/currency/rates").then((r) => setRates(r.data.rates)).catch(() => {});
  }, []);

  useEffect(() => { localStorage.setItem("currency", currency); }, [currency]);

  const format = (usd) => {
    const rate = rates[currency] || 1;
    const val = usd * rate;
    const sym = SYMBOLS[currency] || "$";
    const digits = currency === "NGN" ? 0 : 2;
    return `${sym}${val.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, rates, format }}>
      {children}
    </CurrencyContext.Provider>
  );
}
